/**
 * Created by lari on 08/06/2017.
 */

/* either pass list of doctypes (patients) to display or load doctypes */


(function () {
  'use strict';
  angular.module('vcdms.vcdoctype')
    .component('doctypelist', {
      restrict: 'E',
      bindings: {
        doctypes: '<?'
      },
      template: `
        <h3>Dokumententypen und Drucker</h3>
        <table class="table table-striped">
          <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>XSLT</th>
            <th>Drucker</th>
          </tr>
          </thead>
          <tr ng-repeat="dt in vm.doctypes">
            <td>{{dt._id}}</td>
            <td>{{dt.name}}</td>
            <td>{{dt.stylesheet}}</td>
            <td>{{dt.printer}}</td>
            <td>
              <button class="btn btn-primary" ng-click="vm.editDoctype(dt)"><i class="fa fa-edit" uib-tooltip="Editieren"></i></button>
              <button class="btn btn-danger" ng-click="vm.removeDoctype(dt)"><i class="fa fa-remove" uib-tooltip="Löschen"></i></button>
            </td>
          </tr>
        </table>
      `,
      controllerAs: 'vm',
      controller: ['$log', '$http', 'Rlog', 'Doctype', 'DoctypeHelper', 'vertxEventBusService',
        function ($log, $http, Rlog, Doctype, DoctypeHelper, vertxEventBusService) {
          let vm = this;
          vm.editDoctype = DoctypeHelper.editDoctype;
          vm.removeDoctype = removeDoctype;
          
          vm.$onInit = function () {
            
            // unless vcclient list has been passed for test purposes, retrieve vcclient list from web
            if (angular.isUndefined(vm.doctypes)) {
              vm.doctypes = Doctype.$search();
            }
          }; // $onInit()
          
          
          function removeDoctype(doctype) {
            doctype.active = false;
            doctype.$save();
          }
          
          vertxEventBusService.on('doctypes.update', function (message) {
            $log.debug('debug: doctype update received: ', message);
            let messages = message.split(':');
            vm.doctypes.$refresh().$then(function () {
              $log.debug('debug: doctypelist refreshed doctypes');
            }, function (error) {
              $log.debug('debug: doctypelist refresh doctypes failed: ', error);
            });
          });

        }] // controller
    }); // component
  
  // klammerfriedhof
}());